export enum RefreshEvents {
	GETUSERINFO = "GET_USERINFO",
	REFRESH_COIN_BALANCE = "REFRESH_COIN_BALANCE",
}
